var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFolderOpenCloudColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAAF46",
    d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    d: "M.388 12.745A1.434 1.434 0 0 1 1.788 11H22c1.026 0 1.789.95 1.566 1.952l-1.218 5.482A2 2 0 0 1 20.396 20H3.604a2 2 0 0 1-1.952-1.566L.388 12.745Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M12.75 24a3.75 3.75 0 1 1 .044-7.5 5 5 0 0 1 9.31 2.027 2.815 2.815 0 0 1 1.879 2.348H24c0 .054-.001.107-.004.16A2.813 2.813 0 0 1 21.188 24H12.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDCA35",
    d: "m17 17-3 4h2v3h2v-3h2l-3-4Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9,
    x2: 24,
    y1: 15,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C25EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFolderOpenCloudColored);
export default __webpack_public_path__ + "static/media/ic_action_folder_open_cloud_colored.b03943e01a5e1dab956f084954d2828b.svg";
export { ForwardRef as ReactComponent };